import React from 'react';
import { Link } from 'react-router-dom';
import { Package, Mail, Phone, MapPin } from 'lucide-react';
import { contactInfo } from '../mock';

const Footer = () => {
  return (
    <footer className="bg-slate-900 text-gray-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Company Info */}
          <div className="space-y-4">
            <div className="flex items-center space-x-3">
              <div className="bg-gradient-to-br from-slate-600 to-slate-400 p-2 rounded-lg">
                <Package className="h-6 w-6 text-white" />
              </div>
              <div>
                <span className="text-xl font-bold text-white">SABEY</span>
                <span className="text-xs block text-gray-400 -mt-1">LOGISTICS</span>
              </div>
            </div>
            <p className="text-sm text-gray-400">
              Trusted supply chain logistics solutions with field stocking locations across America.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-sm">
              <li><Link to="/" className="hover:text-white transition-colors">Home</Link></li>
              <li><Link to="/services" className="hover:text-white transition-colors">Services</Link></li>
              <li><Link to="/tracking" className="hover:text-white transition-colors">Track Shipment</Link></li>
              <li><Link to="/about" className="hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h3 className="text-white font-semibold mb-4">Our Services</h3>
            <ul className="space-y-2 text-sm">
              <li className="hover:text-white transition-colors cursor-pointer">Field Stocking Locations</li>
              <li className="hover:text-white transition-colors cursor-pointer">Supply Chain Management</li>
              <li className="hover:text-white transition-colors cursor-pointer">Warehousing & Fulfillment</li>
              <li className="hover:text-white transition-colors cursor-pointer">Rush Delivery</li>
              <li className="hover:text-white transition-colors cursor-pointer">HAZMAT Services</li>
              <li className="hover:text-white transition-colors cursor-pointer">International Shipping</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold mb-4">Contact Us</h3>
            <ul className="space-y-3 text-sm">
              <li className="flex items-start space-x-3">
                <Phone className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.phone}</span>
              </li>
              <li className="flex items-start space-x-3">
                <Mail className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.email}</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="h-4 w-4 mt-0.5 flex-shrink-0" />
                <span>{contactInfo.address}</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-slate-800 mt-8 pt-8 text-center text-sm">
          <p className="text-gray-400">
            © {new Date().getFullYear()} Sabey Logistics. All rights reserved. | TSA Certified Operations
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;